import { RECEIVE_INACTIVE_GEOZONES } from "../constants/actions-type";

export const receiveInactiveGeozones = data => ({
  type: RECEIVE_INACTIVE_GEOZONES,
  inactiveGeozones: data,
});
